import React, {Component} from 'react';
import {Provider} from 'react-redux';
import {PersistGate} from 'redux-persist/integration/react';
import {NotificationContainer} from 'react-notifications';
import 'react-virtualized/styles.css';

import CreateStore from './state/store';
import Router from './Router';
import Bugsnag from './components/Bugsnag';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = CreateStore();
  }

  render() {
    return (
      <Provider store={this.state.store}>
        <PersistGate persistor={this.state.persistor}>
          <Bugsnag>
            <NotificationContainer />
            <Router />
          </Bugsnag>
        </PersistGate>
      </Provider>
    );
  }
}

export default App;
